import { Usuario } from 'src/app/shared/model/security/usuario.model';

export class Login {
     usuario:  Usuario;
     mensaje:  string;
     codigoDeRespuesta: string;
     inactividad: number;
	 mensajeIn: number;

    constructor(){

    }

}
